module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "clickoutside",
      rawName: "v-clickoutside",
      value: (_vm.clickedOutside),
      expression: "clickedOutside"
    }],
    staticClass: "ts-select"
  }, [_c('div', {
    staticClass: "ts-select-toggle",
    class: {
      'is-open': _vm.open, 'is-disabled': _vm.disabled, 'is-small': _vm.size === 'small'
    },
    on: {
      "click": _vm.toggleDropdown
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.selected))])]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "ts-select-fade"
    }
  }, [(_vm.open) ? _c('ul', {
    staticClass: "ts-select-wrapper"
  }, _vm._l((_vm.parsedDataList), function(item) {
    return _c('li', {
      class: {
        'is-selected': _vm.selected == item.name
      },
      on: {
        "click": function($event) {
          _vm.setVal(item)
        }
      }
    }, [_vm._v(_vm._s(item.name))])
  })) : _vm._e()])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-505d7ab1"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/Components/common/select/tsSelect.vue
// module id = 830
// module chunks = 39